import React from 'react';

import { TableHead, TableRow, TableCell } from '@material-ui/core';

import { unCamelCase } from '../../../helpers/camelCase';

const Head = ({ tableCell, action = true, handleChooseItem }) => {
  return (
    <TableHead>
      <TableRow>
        {tableCell.map(data => (
          <TableCell
            onClick={() => {
              handleChooseItem(data);
            }}
            key={data}
          >
            {unCamelCase(data)}
          </TableCell>
        ))}
        {action && <TableCell data-testid="action">Action</TableCell>}
      </TableRow>
    </TableHead>
  );
};

export default Head;
